export { default as TrIcon } from './TrIcon'


// WEBPACK FOOTER //
// ../../src/TrIcon/index.js